<h3 class="modal-title" *ngIf="title">{{ title | translate }}</h3>

<form [formGroup]="form">
  <div class="row-fx-legacy">
    <div class="available-dates-period">
      <p>{{ "input-available-dates" | translate }}</p>
      <mat-calendar
        (selectedChange)="updateFormDate($event)"
        [selected]="form.get('date').value"
        [dateFilter]="filterDatePicker"
        [minDate]="carworkshopMinimumDateAvailableDate"
      ></mat-calendar>
    </div>

    <div class="available-dates-period">
      <p>{{ "label-period" | translate }}</p>
      <mat-radio-group formControlName="period">
        <mat-radio-button
          [value]="period.value"
          *ngFor="let period of periods"
          [disabled]="period.disabled"
          (change)="changePeriod()"
        >
          {{ "period." + period.value | translate }}

          <button
            mat-icon-button
            type="button"
            class="info-icon"
            aria-label="info"
            [matTooltip]="
              period.value == 'MORNING'
                ? ('arrive-period-morning-description' | translate)
                : ('arrive-period-afternoon-description' | translate)
            "
            matTooltipPosition="above"
          >
            <mat-icon fontIcon="Bosch-Ic-information"></mat-icon>
          </button>
        </mat-radio-button>
      </mat-radio-group>

      <p class="slots-description">
        {{ "slots-scheduling-description" | translate }}
      </p>
    </div>
  </div>
</form>
